import addError from '../../../utils/error.jsx';

export function request({ data }) {
    return {
        type: 'SYSTEM_SETTINGS_PUT_BET_LIMIT_REQUEST',
        data
    };
}

export function error(errors) {
    addError(errors);
    return {
        type: 'SYSTEM_SETTINGS_PUT_BET_LIMIT_ERROR',
        errors
    };
}

export function finish(data) {
    return {
        type: 'SYSTEM_SETTINGS_PUT_BET_LIMIT_FINISH',
        data: data
    };
}
